import { render } from "./SideNavigator.vue?vue&type=template&id=92246798"
import script from "./SideNavigator.vue?vue&type=script&lang=js"
export * from "./SideNavigator.vue?vue&type=script&lang=js"
script.render = render

export default script